export const types = {
  USER_ADD: 'USER_ADD',
  USER_UPDATE: 'USER_UPDATE',
  USER_REMOVE: 'USER_REMOVE',
  EDIT_EMPLOYEE_PAYROLL: 'EDIT_EMPLOYEE_PAYROLL',
  ID_EMPLOYEE_SELECTED: 'ID_EMPLOYEE_SELECTED',
  SORT_EMPLOYEE: 'SORT_EMPLOYEE',
  ORGANIZATIONS_LIST: 'ORGANIZATIONS_LIST',
};
